import React from "react";
import { VariantProps } from ".";
import Standard from "../Price";

const U = ({ selectedProduct }: VariantProps) => {
  return (
    <div className="map map-override mapU">
      <Standard
        price={selectedProduct.price.price}
        unitOfMeasure={selectedProduct.unitOfMeasure}
      />
    </div>
  );
};

export default U;
